import { useState, useContext, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Theme } from '@mui/material';
import styled from '@emotion/styled';

import { DataContext } from 'providers/data';
import { ParamsPageWebView } from 'utils/typeServices';

import { Typography, Box, Collapse } from '@mui/material';

import ParseWebView from 'components/views/ParseWebView';
import { ButtonRectangle } from 'components/views/form/Button';

type ParamsStyle = {
    theme?: Theme;
}

export const BoxSvg = styled('div')(
    ({ theme }: ParamsStyle) => `
        position: absolute;
        right: 80px;
        top: 20px;

        svg {
            transition: all 0.4s ease;
        }

        &.show {
            svg {
                transform: rotate(180deg);
            }
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            
        }
`);

const OrderSummary = ({ isWebView }: ParamsPageWebView) => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { dataProductCart, dataQuoteListservices, dataGetListarCotacoes, selectedCar, handleGetOrdersByCustomerId, handleParseProductCart, dataValidateChoose, dataConfirmOrder, handleGetInitialServices, handleGetUsefulContacts } = useContext(DataContext);
    const [showDetails, setShowDetails] = useState(false);
    const [initialServicesLoaded, setInitialServicesLoaded] = useState(false);

    const handleParseProductCartState = () => {
        if (dataGetListarCotacoes?.quoteItemsChooses && selectedCar) {
            handleParseProductCart({
                body: {
                    cD_COTACAO: dataGetListarCotacoes.quote.cD_COTACAO,
                    cD_PEDIDO: state.cD_PEDIDO,
                    customerId: selectedCar.CD_PESSOA,
                    quoteItemsChooses: dataGetListarCotacoes?.quoteItemsChooses
                }
            });
        }
    }

    const isScheduling = () => {
        if(dataConfirmOrder){
            return (
                dataValidateChoose?.data?.fL_AGENDAMENTO &&
                dataConfirmOrder &&
                !dataConfirmOrder?.fL_ATENDIMENTO_INICIAL_MANUTENCAO
            );
        }else{
            return dataValidateChoose?.data?.fL_AGENDAMENTO;
        }

    };

    const isMaintenance = () => {
        if(dataConfirmOrder){
            return (
                dataConfirmOrder.fL_ATENDIMENTO_INICIAL_MANUTENCAO
            );
        }else{
            return false;
        }
    }

    useEffect(() => {
        if (state?.isExchangesInProgress) {
            handleParseProductCartState();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state]);

    useEffect(() => {
        if (!isScheduling() && !initialServicesLoaded){
            var token = localStorage.getItem('token')!
            handleGetInitialServices({
                token: token,
                isWebView: true,
            });
            handleGetUsefulContacts({ token: token });
            setInitialServicesLoaded(true);
        };

    }, [isScheduling, initialServicesLoaded ,handleGetInitialServices]);

    const quotationOrOrderNumberLabel = isScheduling() ? 'NÚMERO DA COTAÇÃO' : 'PEDIDO NÚMERO';
    const quotationOrOrderNumber = isScheduling() ? dataConfirmOrder && dataConfirmOrder?.order?.cD_COTACAO
                                                  : dataConfirmOrder && dataConfirmOrder?.order?.cD_PEDIDO;

    return (
        <ParseWebView isWebView={isWebView} typePage='subpage'>
            <Box sx={{ alignItems: 'center', display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                <Box sx={{ textAlign: 'center' }}>
                    <Typography sx={{ fontSize: '1.5625rem' }}>
                        Agradecemos a <strong style={{ color: '#97C93D' }}>confiança!</strong>
                    </Typography>

                    {
                        isScheduling() ?

                            <Typography sx={{ fontSize: '1.125rem', marginTop: '.5rem' }}>
                                A sua vistoria foi <strong>agendada com sucesso!</strong>
                            </Typography> :

                            <Typography sx={{ fontSize: '1.125rem', marginTop: '.5rem' }}>
                                A sua troca foi <strong>realizada com sucesso!</strong>
                            </Typography>
                    }

                    <Typography sx={{ fontSize: '1rem', marginTop: '1rem' }}>
                        Enviamos um e-mail com todas as informações do seu pedido.
                    </Typography>

                    {
                        !isScheduling() && 
                        <Typography  sx={{ fontSize: '1rem', marginTop: '1rem' }}>
                            Neste email, você também receberá o <strong>termo de adesão</strong>, que deverá ser <strong>
                                assinado e encaminhado para</strong>:
                            <br/>
                            <br/>
                            <strong> termo.assinado@ituran.com.br</strong>
                        </Typography>
                    }

                    {
                        (!dataValidateChoose?.data?.fL_AGENDAMENTO || isMaintenance()) &&

                        <Typography sx={{ fontSize: '0.8rem', marginTop: '1rem' }}>
                            <strong>
                                O novo plano escolhido
                                {dataValidateChoose?.data?.nR_TIPO_PRODUTO === 11 ?
                                    ' já está ativo' :
                                    ' estará ativo após 24 horas'
                                }.
                            </strong>
                        </Typography>
                    }
                </Box>

                <Box sx={{ display: 'flex', paddingTop: { xs: '2rem', md: '1.375rem' }, flexDirection: 'column', alignItems: 'center', maxWidth: '600px'}}>
                    <Typography fontSize='1rem' color='white' fontWeight={700} padding='9px 2.125rem 4px' sx={{ backgroundColor: 'primary.light', width: 'fit-content', marginBottom: '5px' }}>
                        IMPORTANTE:
                    </Typography>
                    <Typography lineHeight='19px' sx={{ fontSize: { xs: '.875rem', md: '1rem' }, border: '1.4px solid #17A7E0', borderRadius: '5px', padding: { xs: '.875rem .5rem', md: '.875rem 1.6rem' } }}>
                        {
                            isScheduling() &&
                            <p>
                                &bull; Caso <strong>não seja o segurado</strong> quem irá levar o carro para fazer a vistoria, é <br />
                                necessário imprimir e assinar o “Termos de autorização de instalação para <br />
                                terceiros”, verifique seu e-mail.
                                <br />
                                <br />
                                &bull; <strong>Condições:</strong> Para vistoria em loja, o veículo não pode ter avarias e a <br />
                                documentação precisa estar regularizada.
                                <br />
                                <br />
                                &bull; O novo plano escolhido só é considerado ativo, depois da vistoria em loja.
                                <br />
                                <br />
                            </p>
                        }
                         <p>&bull; Se você já tem um <strong>boleto emitido vencido ou a vencer</strong>, você deve realizar o
                                   pagamento integral, pois se houver valores a mais, esses valores serão dados como 
                                   crédito na próxima mensalidade.
                         </p>
                    </Typography>
                </Box>

                <Box sx={{ maxWidth: '34rem', margin: '.875rem auto 0', borderBottom: showDetails ? 'none' : '1px solid #0C1C33' }}>
                    <Box sx={{ backgroundColor: 'primary.main', borderRadius: '10px 10px 0px 0px', height: '10px' }} />
                    <Box sx={{ cursor: 'pointer', display: 'flex', position: 'relative', justifyContent: 'center' }} onClick={() => setShowDetails(!showDetails)}>
                        <Typography sx={{ fontSize: '1.5625rem', textAlign: 'center', fontWeight: 700, padding: '1.3125rem 0', 'strong': { color: 'secondary.main' } }}>
                            Resumo da sua <strong>{isScheduling() ? 'compra:' : 'troca'} </strong>
                        </Typography>
                    </Box>
                    <Collapse in={true}>
                        <Box sx={{ maxWidth: '27.18rem', margin: '0 auto' }}>
                            <Typography sx={{ textAlign: 'center', fontSize: '1.25rem', marginBottom: '1.375rem', padding: '.5625rem', border: '1px solid #0C1C33', borderRadius: '129px' }}>
                                {quotationOrOrderNumberLabel}: <strong>{quotationOrOrderNumber} </strong>
                            </Typography>

                            <Box>
                                <Typography sx={{
                                    fontWeight: 700,
                                    fontSize: '1.25rem',
                                    width: 'fit-content',
                                    background: '#97C93D',
                                    borderRadius: '5px 5px 0px 0px',
                                    padding: '.3rem 1.5rem .1rem .4rem'
                                }}>
                                    Veículo
                                </Typography>
                                <Box sx={{ borderBottom: '1px solid #0C1C33' }} />

                                <Box sx={{ padding: '.875rem 0 1.5rem', display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
                                    <Typography sx={{ fontSize: '.875rem', paddingBottom: '.75rem' }}>
                                        <strong>Placa:&nbsp;</strong>
                                        {dataQuoteListservices && dataQuoteListservices?.dS_PLACA}
                                    </Typography>
                                    <Typography sx={{ fontSize: '.875rem', paddingBottom: '.75rem', textAlign: 'end' }}>
                                        <strong>Ano modelo:&nbsp;</strong>
                                        {dataQuoteListservices && dataQuoteListservices?.nR_ANO}
                                    </Typography>
                                    <Typography sx={{ fontSize: '.875rem', paddingBottom: '.75rem' }}>
                                        <strong>Modelo:&nbsp;</strong>
                                        {dataQuoteListservices && dataQuoteListservices?.nM_MODELO}
                                    </Typography>
                                </Box>
                            </Box>
                            <Box>
                                <Typography sx={{
                                    fontWeight: 700,
                                    fontSize: '1.25rem',
                                    width: 'fit-content',
                                    background: '#97C93D',
                                    borderRadius: '5px 5px 0px 0px',
                                    padding: '.3rem 1.5rem .1rem .4rem'
                                }}>
                                    Produto
                                </Typography>
                                <Box sx={{ borderBottom: '1px solid #0C1C33' }} />

                                <Box sx={{ padding: '.875rem 0 1.5rem' }}>
                                    <Typography sx={{ fontSize: '.875rem', paddingBottom: '.2rem', fontWeight: 700 }}>
                                        {dataProductCart.productPlan.nM_PRODUTO}
                                    </Typography>
                                    <Typography sx={{ fontSize: '.875rem', paddingBottom: '.75rem', fontWeight: 400 }}>
                                        {dataProductCart.productPlan.nR_PORCENTAGEM_INDENIZACAO ?
                                            <p>{dataProductCart.productPlan.nR_PORCENTAGEM_INDENIZACAO}% da FIPE</p>
                                            :
                                            <span></span>
                                        }
                                        {dataProductCart.productPlan.dS_PRODUTO ?
                                            <span style={{ display: 'flex', paddingTop: '.2rem', fontSize: '.75rem', fontWeight: '400', lineHeight: '12px' }}>
                                                {dataProductCart.productPlan.dS_PRODUTO}
                                            </span>
                                            :
                                            <div></div>
                                        }
                                    </Typography>
                                </Box>
                            </Box>
                            <Box>
                                <Typography sx={{
                                    fontWeight: 700,
                                    fontSize: '1.25rem',
                                    width: 'fit-content',
                                    background: '#97C93D',
                                    borderRadius: '5px 5px 0px 0px',
                                    padding: '.3rem 1.5rem .1rem .4rem'
                                }}>
                                    Serviços adicionais
                                </Typography>
                                <Box sx={{ borderBottom: '1px solid #0C1C33' }} />

                                <Box sx={{ padding: '.875rem 0 1.5rem', display: 'grid', gridTemplateColumns: '1fr' }}>
                                    {dataProductCart.productAdd.map(({ nM_PRODUTO }, index) =>
                                        <Typography key={index} sx={{ fontSize: '.875rem', paddingBottom: '.75rem', fontWeight: 700 }}>
                                            {nM_PRODUTO}
                                        </Typography>
                                    )}
                                </Box>
                            </Box>
                            <Box sx={{ 'button': { width: '100%', height: '2.5rem' }, marginBottom: '1.5rem' }}>
                                {
                                    isScheduling() &&
                                    <ButtonRectangle name='VER AGENDAMENTO' onClick={() => { navigate(`${isWebView ? '/wb' : ''}/agendamentos`); handleGetOrdersByCustomerId({ token: localStorage.getItem('token')! }); }} />
                                }
                            </Box>
                        </Box>
                    </Collapse>
                </Box>
            </Box >
        </ParseWebView>
    );
}

export default OrderSummary;